import { render, staticRenderFns } from "./PackageTypesFormInput.vue?vue&type=template&id=56a8ecc9&scoped=true&"
import script from "./PackageTypesFormInput.vue?vue&type=script&lang=js&"
export * from "./PackageTypesFormInput.vue?vue&type=script&lang=js&"
import style0 from "./PackageTypesFormInput.vue?vue&type=style&index=0&id=56a8ecc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8ecc9",
  null
  
)

/* custom blocks */
import block0 from "./PackageTypesFormInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports